import {IMenuItemConfigReader} from "../menu-item-config-reader/menu-item-config-reader.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {CustomMenuItemRendererConstructorDefinition, IMenuItemRenderer} from "./menu-item.renderer.interface";
import {MenuItemKey} from "../../configurations/config-data-sections/generated-config-const";

export function loadCustomMenuItemsRenderers(rendererModules: any[],
                                             menuItemConfigReader: IMenuItemConfigReader,
                                             services: IServiceFactoryExtended): Record<MenuItemKey, IMenuItemRenderer> {
        return rendererModules.map((module: any) => {
            const RendererConstructor: CustomMenuItemRendererConstructorDefinition = module.default;
            return new RendererConstructor(menuItemConfigReader, services);
        }).toDictionary(item => item.key);
}

